import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';
import { Icon, Table, Tooltip, Modal } from 'antd';

import getEditableFormRow from './EditableRow';
import EditableCell from './EditableCell';


/* eslint-disable react/display-name */
const EditableContext = createContext();

export default class UpdateableTable extends Component {
    static propTypes = {
      columns: PropTypes.arrayOf(PropTypes.object).isRequired,
      data: PropTypes.array,
      updateFun: PropTypes.func.isRequired,
      createable: PropTypes.bool,
      appendDefaultData: PropTypes.func,
      deleteData: PropTypes.func,
      deleteable: PropTypes.bool,
    }

    state = {
      editingKey: '',
      creatingId: '',
      visibleModal: false,
    }

    isEditing = record => record.id === this.state.editingKey

    actionCol = {
      align: 'center',
      title: 'Operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = this.isEditing(record);
        return (
          <div>
            {editable ? (
              <span>
                <EditableContext.Consumer>
                  {form => (
                    <Tooltip title="Save">
                      <Icon
                        type="check-circle"
                        onClick={() => this.updateData(form, record.id)}
                        theme="twoTone"
                        twoToneColor="green"
                        style={ { cursor: 'pointer', fontSize: '20px', marginRight: '8px' } }
                      />
                    </Tooltip>
                  )}
                </EditableContext.Consumer>
                <Tooltip title="Cancel">
                  <Icon
                    type="close-circle"
                    onClick={() => this.cancelEditing(record)}
                    theme="twoTone"
                    twoToneColor="red"
                    style={ { cursor: 'pointer', fontSize: '20px' } }
                  />
                </Tooltip>
              </span>
            ) : (
              <span>
                <Tooltip title='Edit'>
                  <Icon
                    type="edit"
                    onClick={() => this.startEditing(record)}
                    theme="twoTone"
                    twoToneColor="blue"
                    style={ { cursor: 'pointer', fontSize: '20px', marginRight: '8px' } }
                  />
                </Tooltip>
                { this.props.deleteable ? (
                  <Tooltip title='Delete'>
                    <Icon
                      type="delete"
                      onClick={() => this.deleteData(record)}
                      theme="twoTone"
                      twoToneColor="red"
                      style={ { cursor: 'pointer', fontSize: '20px' } }
                    />
                  </Tooltip>) : undefined
                }
              </span>
            )}
          </div>
        );
      }
    };

    startEditing(record) {
      const { creatingId } = this.state;

      if (creatingId === '') {
        this.setState({ editingKey: record.id });
      } else {
        this.setState({ visibleModal: true });
      }
    }

    cancelEditing(record) {
      const { creatingId } = this.state;

      if (record.id === creatingId) {
        this.deleteData(record);
      } else {
        this.setState({ editingKey: '' });
      }
    }

    updateData(form) {
      const { data, updateFun } = this.props;
      const { editingKey } = this.state;
      form.validateFields((error) => {
        if (error) {
          return;
        }
        const record = data.find(record => record.id === editingKey);
        const formdata = form.getFieldsValue();
        const newRecord = {
          ...record,
          ...formdata
        };
        if (newRecord) {
          updateFun(newRecord).then(() => this.setState({ editingKey: '', creatingId: '' }));
        }
      });
    }

    deleteData(data) {
      const { deleteData } = this.props;
      deleteData(data);
    }

    createData() {
      const { appendDefaultData } = this.props;

      appendDefaultData().then((res) => {
        this.setState({ editingKey: res.id, creatingId: res.id });
      });
    }

    render() {
      const { columns, createable, data } = this.props;
      const { editingKey, visibleModal } = this.state;

      const components = {
        body: {
          row: getEditableFormRow(EditableContext),
          cell: EditableCell
        },
      };
      const mappedColumns = [...columns, this.actionCol].map((col) => {
        if (!col.editable) {
          return {
            ...col,
            onCell: () => ({
              EditableContext,
              editing: false,
            })
          };
        }
        return {
          ...col,
          onCell: record => ({
            record,
            getInput: col.getInput,
            dataIndex: col.dataIndex,
            title: col.title,
            editing: this.isEditing(record),
            EditableContext,
            required: col.required
          })
        };
      });

      let tableFooter;
      const hideCreate = data.filter(entry => entry.id === editingKey).length > 0;
      if (createable) {
        tableFooter = () => {
          return (
            <div style={ { display: 'flex', flex: 1 } }>
              <Tooltip title={hideCreate ? 'Finish editing to create a new entry' : 'Add New Entry'}>
                <Icon
                  type='plus-circle'
                  onClick={hideCreate ? undefined : () => this.createData()}
                  theme='twoTone'
                  twoToneColor={hideCreate ? 'grey' : 'green'}
                  style={ { cursor: 'pointer', fontSize: '30px', marginLeft: 'auto' } }
                />
              </Tooltip>
            </div>
          );
        };
      } else {
        tableFooter = undefined;
      }

      return (
        <div>
          <Table
            { ...this.props }
            components={components}
            bordered
            dataSource={data}
            columns={mappedColumns}
            rowClassName='editable-row'
            footer={tableFooter}
          />
          <Modal
            title="Can't Edit Entry"
            visible={visibleModal}
            onOk={() => this.setState({ visibleModal: false })}
            onCancel={() => this.setState({ visibleModal: false })}>
            You can not edit an entry whilst creating a new entry.
            Please finish creating the current entry.
          </Modal>
        </div>
      );
    }
}